import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=60eddbf0&scoped=true&"
import script from "./InvoicePreview.vue?vue&type=script&lang=js&"
export * from "./InvoicePreview.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePreview.vue?vue&type=style&index=0&id=60eddbf0&lang=scss&scoped=true&"
import style1 from "./InvoicePreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eddbf0",
  null
  
)

export default component.exports